import polyglotI18nProvider from 'ra-i18n-polyglot';
import * as constants from  '../../constants'

/*import englishMessages from 'ra-language-english';
import farsiMessages from 'ra-language-farsi';

import customPersianMessages from './fa';
import customEnglishMessages from './en';

const messages : any =  {
    fa: { ...farsiMessages, ...customPersianMessages },
    en: { ...englishMessages, ...customEnglishMessages },
};
const i18nProvider = polyglotI18nProvider((locale : string) => 
    messages[locale],
    defaultLocale // Default locale
);*/



import farsiMessages from 'ra-language-farsi';
import customPersianMessages from './fa';
let defaultLocale = constants.configuration.DEFAULT_LANGUAGE;


const i18nProvider = polyglotI18nProvider((locale : string) => { 
    if (locale === 'en') {
    	const englishMessages = import('ra-language-english').then((messages : any) => messages.default)
    	const customEnglishMessages = import('./en').then((messages : any) => messages.default)

    	return { ...englishMessages, ...customEnglishMessages };
    }
    if (locale === 'fa') {
    	//const farsiMessages = import('ra-language-farsi').then((messages : any) => messages.default)
    	//const customPersianMessages = import('./fa').then((messages : any) => messages.default)

    	return { ...farsiMessages, ...customPersianMessages };
    }
}, defaultLocale);


export default i18nProvider;
